export default "__VITE_ASSET__DO1La8Tn__"